import MusicVideoIcon from '@mui/icons-material/MusicVideo';
import { useContext } from 'react';
import { FixtureAction } from '@/service/types';
import { ARIA_LABEL } from '@/constants/ariaLabel';
import { AudioRecordsContext } from '@/contexts/audioRecords/context';
import { AnimatedIconButton } from '../common/AnimatedIconButton';
import { BUTTON_NAME } from './constants';

export interface AudioCellProps {
  action: FixtureAction;
}

export const AudioCell = ({ action }: AudioCellProps) => {
  const { records } = useContext(AudioRecordsContext);

  const isPeriodRecord = records.find(
    (record) => record.periodNo === action.period,
  );

  if (!isPeriodRecord) {
    return <span />;
  }

  return (
    <AnimatedIconButton
      name={BUTTON_NAME.AUDIO}
      size='small'
      aria-label={ARIA_LABEL.AUDIO}
    >
      <MusicVideoIcon fontSize='small' />
    </AnimatedIconButton>
  );
};
